<template>
  <div>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div
      id="content"
      class="login"
      style="
        display: flex !important;
        align-items: flex-start !important;
        justify-content: center !important;
        min-height: 100vh;
        padding: 20px 0;
        overflow-y: auto;
      "
    >
      <!-- <br> -->
      <div class="card card-style" style="width: 100%">
        <div class="content">
          <div style="text-align: center !important">
            <img
              src="../assets/images/logo_samu.png"
              alt="logo"
              height="55"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
            <img
              src="../assets/images/image.png"
              alt="logo"
              height="55"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
          </div>

          <!-- <h1 class="text-center font-800 font-30 mb-2">Sign In</h1> -->

          <p class="text-left font-13 mt-n2 mb-3">
            Preencha os dados abaixo para se cadastrar
          </p>

          <div class="mb-3">
            <label for="cpf" class="color-theme mb-2 d-block"
              >CPF <span>(obrigatório)</span></label
            >
            <input
              type="tel"
              class="form-control rounded-xs"
              id="cpf"
              v-model="users.cpf"
              v-mask="'999.999.999-99'"
              autocomplete="new-password"
            />
          </div>

          <div class="mb-3">
            <label for="nome" class="color-theme mb-2 d-block"
              >Nome Completo <span>(obrigatório)</span></label
            >
            <input
              type="text"
              class="form-control rounded-xs"
              id="nome"
              v-model="users.usuario_nome"
            />
          </div>

          <div class="mb-3">
            <label for="email" class="color-theme mb-2 d-block"
              >E-mail <span>(obrigatório)</span></label
            >
            <input
              type="email"
              class="form-control rounded-xs"
              id="email"
              v-model="users.email"
            />
          </div>

          <div class="mb-3">
            <label for="data_nascimento" class="color-theme mb-2 d-block"
              >Data Nascimento</label
            >
            <input
              type="date"
              class="form-control rounded-xs"
              id="data_nascimento"
              v-model="users.data_nascimento"
            />
          </div>

          <!-- <div class="form-custom form-label mb-3">
            <input
              type="text"
              class="form-control rounded-xs"
              id="c1"
              placeholder="Cidade"
              v-model="users.cidade"
              autocomplete="new-password"
            />
            <label for="c1" class="color-theme">Cidade</label>
            <span>(obrigatório)</span>
          </div> -->

          <div class="mb-3">
            <label for="telefone1" class="color-theme mb-2 d-block"
              >Telefone 1 <span>(obrigatório)</span></label
            >
            <input
              type="tel"
              class="form-control rounded-xs"
              id="telefone1"
              v-mask="'(99) 99999-9999'"
              v-model="users.telefone"
              autocomplete="new-password"
            />
          </div>

          <div class="mb-3">
            <label for="telefone2" class="color-theme mb-2 d-block"
              >Telefone 2</label
            >
            <input
              type="text"
              class="form-control rounded-xs"
              id="telefone2"
              v-model="users.telefone2"
              autocomplete="new-password"
            />
          </div>

          <div class="mb-3">
            <label for="senha" class="color-theme mb-2 d-block"
              >Senha <span>(obrigatório)</span></label
            >
            <input
              type="password"
              class="form-control rounded-xs"
              id="senha"
              v-model="users.senha"
              autocomplete="new-password"
            />
          </div>

          <div class="mb-3">
            <label for="senha" class="color-theme mb-2 d-block"
              >Confirmar Senha <span>(obrigatório)</span></label
            >
            <input
              type="password"
              class="form-control rounded-xs"
              id="senha_confirmacao"
              placeholder=" "
              v-model="users.senha_confirmacao"
              autocomplete="new-password"
            />
          </div>

          <a
            href="#"
            style="background-color: #15488a !important"
            class="btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full shadow-bg shadow-bg-s"
            @click="cadastrar"
            >CADASTRAR</a
          >
        </div>
        <b-modal
          id="modalConsentimento"
          title="Termos de Uso"
          @ok="confirmarConsentimento(true)"
          @cancel="confirmarConsentimento(false)"
          hide-footer
        >
          <div>
            <div class="row justify-content-center">
              <div style="text-align: center !important">
                <img
                  src="../assets/images/logo_samu.png"
                  alt="logo"
                  height="55"
                  style="
                    margin-top: 0.5rem !important;
                    margin-bottom: 30px !important;
                  "
                />
                <img
                  src="../assets/images/image.png"
                  alt="logo"
                  height="55"
                  style="
                    margin-top: 0.5rem !important;
                    margin-bottom: 30px !important;
                  "
                />
              </div>
              <div class="col-12" style="text-align: left">
                <strong>IMPORTANTE:</strong>
                <p>
                  Estes termos e condições gerais de uso aplicam-se às
                  atividades relativas ao aplicativo denominado SAMU Capital-RJ
                  Digital, desenvolvido pela empresa IT4D Soluções LTDA,
                  registrada sob o CNPJ 04.510.666/0001-40 e tem sua sede
                  localizada na Avenida Yojiro Takaoka, 4384 - Alphaville,
                  Santana de Parnaiba - SP, 06.541-038. O aplicatido SAMU
                  Capital-RJ Digital foi desenvolvido com o intuito de
                  disponibilizar a comunicação, de forma ágil e segura, de
                  usuários que necessitados ao serviço prestados pelo SAMU
                  Capital do Rio de Janeiro.
                </p>
              </div>
              <div v-if="showWarning" class="alert alert-warning mt-3">
                É obrigatório aceitar os termos!
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              style="margin-right: 5px"
              variant="success"
              @click="confirmarConsentimento(true)"
              >Aceitar</b-button
            >
            <b-button variant="danger" @click="confirmarConsentimento(false)"
              >Rejeitar</b-button
            >
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      new_path: "/dashboard",
      loadingColor: "#5D9CEC",
      email: "",
      password: "",
      forgot: {
        email: ""
      },
      users: {
        cpf: "",
        telefone: "",
        telefone2: "",
        cidade: "",
        usuario_nome: "",
        login: "",
        perfil_id: 2,
        senha: "",
        senha_confirmacao: "",
        data_nascimento: ""
      },
      isLoading: false,
      showWarning: false
    };
  },
  computed: {},
  methods: {
    openModal() {
      this.showWarning = false; // Reseta o aviso ao abrir o modal
      this.$bvModal.show("modalConsentimento");
    },
    confirmarConsentimento(aceitar) {
      if (aceitar) {
        this.login(); // Chama a função de login se aceitar
      } else {
        this.showWarning = true; // Mostra o aviso se rejeitar
      }
    },
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    makeFormData() {
      const self = this;
      let fd = new FormData();

      /* let photo = document.getElementById("userPic"); */

      fd.append("usuario_nome", self.users.usuario_nome);
      fd.append("login", self.users.login ? self.users.login : "");
      fd.append("cpf", self.users.cpf);
      fd.append("perfil_id", self.users.perfil_id);
      fd.append("senha", self.users.senha);
      fd.append("telefone", self.users.telefone);
      fd.append("telefone2", self.users.telefone2);
      fd.append("cidade", self.users.cidade);
      fd.append("senha_confirmacao", self.users.senha_confirmacao);
      fd.append("data_nascimento", self.users.data_nascimento);

      fd.append("_method", "POST");

      /* fd.append("foto", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      } */

      return fd;
    },
    buscarCPF: function() {
      var self = this;

      self.naoLocalizado = false;

      if (self.users.cpf.replace(/\D/g, "").length === 11) {
        self.isLoading = true;
        var cpf = self.users.cpf.replace(/\.|\-/g, "");

        $.getJSON(
          "http://sigap.it4d.com.br/index.php/pesquisaCpfSus?cpf=" + cpf,
          function(data) {
            if (data.erro == "CPF não encontrado") {
              self.isLoading = false;
              return;
            }

            self.users.usuario_nome = data.nome;
            self.users.cpf = data.cpf;
            self.isLoading = false;
          }
        );
      }
    },

    cadastrar() {
      const self = this;
      let api = self.$store.state.api + "users/add-solicitante";

      if (!self.users.email) {
        self.$message(null, "O campo E-mail obrigatorio.", "error");
        self.isLoading = false;
        return;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            "Sucesso",
            `Cadastro realizado com sucesso!`,
            "success"
          );
          self.openModal();
          self.isLoading = false;
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },

    aplicarMascaraCpf(cpf) {
      cpf = this.users.cpf.replace(/\D/g, "");

      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    login() {
      let self = this;
      self.isLoading = true;
      const cpfComMascara = self.aplicarMascaraCpf(self.users.cpf);
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          cpf: cpfComMascara,
          senha: this.users.senha
        })
        .then(response => {
          self.$store.commit("auth", response.data.access_token);
          self.$store.commit("usuario_id", response.data.usuario_id);
          self.$store.commit("usuario_nome", response.data.usuario_nome);
          self.isLoading = false;
          self.$router.push({ path: this.new_path });
        })
        .catch(error => {
          self.isLoading = false;
          self.$message("Erro", "Credenciais incorretas", "error");
        });
    }

    /* forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
  },
  components: { Loading },
  props: {},
  mounted: function() {
    const self = this;

    var url = self.$route.fullPath.split("?url=%2F");
    if (url[1]) {
      self.new_path = url[1];
    }
  }
};
</script>
<style scoped>
input {
  color: black;
}

label {
  margin-bottom: -3px;
  margin-top: 3px;
}

.login a {
  color: #ffffff;
}

/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/CriarConta.vue